import React from 'react';
import { GoTriangleRight } from 'react-icons/go';
import { IconContext } from "react-icons";
import "./ProgressIndicator.css";
import { Typography } from '@mui/material';
import moment from 'moment'

interface ProgressIndicatorProps {
    /** Whether or not the indicator is active */
    active: boolean;
    /** Position of the progress indicator from the top as a percent */
    position: number;
}

export const ProgressIndicator = (props: ProgressIndicatorProps): React.ReactElement => {
    const { active, position } = props;
    return (
        <div className="indicatorArea">
            <div className="progressIndicator" 
                style={{
                    top: `calc(${position}% - 18px)`,
                    transition: "top 0.1s linear",
                    visibility: active ? 'visible' : 'hidden'
                }}>
                <Typography id="currentTime">{moment().format('h:mm a')}</Typography>
                <IconContext.Provider value={{color: 'rgba(60, 60, 60)'}}>
                    <GoTriangleRight className="triangle"/>
                </IconContext.Provider>
                <div className="horizontal"></div>
            </div>
        </div>
        
    )
}

export default ProgressIndicator;